import { Metadata } from '../../../../utils/spds/metadata';
import Super from './base.gjs';

const METADATA = Metadata.define({
  description: `
Flex row layout component

A convenience wrapper around \`Spds::Core::Container\` that renders a flexbox row. The core container already defaults
to a row, but this component declares the layout explicitly, which makes templates more self-documenting and easier to
read at a glance.
  `,
  name: 'Flex Row',
});

export default class SpdsLayoutFlexRow extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  column = false;
  variantClass = 'spds-layout-flex-row';
}

export const LAYOUT_FLEX_ROW_METADATA = SpdsLayoutFlexRow.metadata;
